export default __webpack_public_path__ + "static/media/reims11.f4efc302.jpg";